import { UnknownError } from '@cian/peperrors';
import { useCallback } from 'react';
import { EExceptionDomain } from '../../../types/exceptionDomains';
import { useApplicationContext } from '../../../utils/applicationContext';
import { getGenericLikeError } from '../../../utils/logging/getGenericLikeError';

const DEFAULT_EXCEPTION_MESSAGE = 'Не удалось открыть модалку авторизации через микрофронт шапки';

export const useAuth = () => {
  const { microfrontendsAPI, logger } = useApplicationContext();

  return useCallback(async () => {
    try {
      if (!microfrontendsAPI) {
        throw new UnknownError({
          domain: EExceptionDomain.Auth,
          message: DEFAULT_EXCEPTION_MESSAGE,
        });
      }

      await microfrontendsAPI.header.openAuthModal({ autoRefresh: true });
    } catch (error) {
      const exception = getGenericLikeError({
        domain: EExceptionDomain.Auth,
        message: DEFAULT_EXCEPTION_MESSAGE,
        error,
      });

      logger.error(exception);
    }
  }, [microfrontendsAPI, logger]);
};
